
import {HttpModelConverter} from "../../../../core/converter/httpModel.converter";
import {Injectable} from "@angular/core";
import {PermissionsConverter} from "../../../../common/converter/permissions.converter";
import {InsolesProfileSummaryModel} from "./insolesProfileSummary.model";
import {ProviderSummaryConverter} from "../../../../provider/common/api/entity/converter/providerSummary.converter";

@Injectable({
    providedIn: 'root'
})
export class InsolesProfileSummaryConverter extends HttpModelConverter<InsolesProfileSummaryModel> {

    constructor(private permissionConverter: PermissionsConverter,
                private providerConverter: ProviderSummaryConverter) {
        super();
    }

    protected createInstance(): InsolesProfileSummaryModel {
        return new InsolesProfileSummaryModel();
    }

    protected enrichObject(result: InsolesProfileSummaryModel, src: InsolesProfileSummaryModel) {
        result.permissions = this.permissionConverter.convert(src.permissions);
        result.provider = this.providerConverter.convert(src.provider);
    }

}